import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import LogoMorphScene from '../showcase/LogoMorphScene';

// Hero right-side visual: a particle cloud that forms the VH mark and morphs into the
// Bolt logo on a loop (with an interactive cursor-repulsion wake). Brand-led, so there's
// no per-capability icon rail here.
const EASE = [0.22, 1, 0.36, 1];

export default function HeroCapabilityVisual() {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? { opacity: 0 } : { opacity: 0, y: 24, scale: 0.98 }}
      animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.8, ease: EASE, delay: 0.25 }}
      className="relative w-full h-[400px] sm:h-[460px] lg:h-[520px]"
    >
      <LogoMorphScene light transparent />
    </motion.div>
  );
}
